import React from 'react';

function Footer() {
    return (
        <footer className="bg-[#1C3324] py-10 px-6">
            <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">
                <div>
                    <h6 className="text-xs uppercase tracking-wide font-bold text-white/60 mb-3">Socials</h6>
                    <div className="flex gap-3">
                        <a target="_blank" rel="noreferrer" href="https://x.com/peticle_app" className="text-white hover:text-brand-light transition-colors">
                            <i className="fa fa-twitter"></i>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/peticle.app" className="text-white hover:text-brand-light transition-colors">
                            <i className="fa fa-instagram"></i>
                        </a>
                    </div>
                </div>

                <div>
                    <h6 className="text-xs uppercase tracking-wide font-bold text-white/60 mb-3">Contact</h6>
                    <p className="text-white/90 text-sm flex items-center gap-2">
                        <i className="fa fa-envelope"></i>
                        hello@unit326.com
                    </p>
                </div>

                <div>
                    <h6 className="text-xs uppercase tracking-wide font-bold text-white/60 mb-3">Legal</h6>
                    <div className="flex flex-col gap-1.5">
                        <a href="/privacy-policy" className="text-white/90 text-sm hover:text-white transition-colors">Privacy Policy</a>
                        <a href="/data-settings" className="text-white/90 text-sm hover:text-white transition-colors">Data Settings</a>
                    </div>
                </div>
            </div>
            <hr className="border-white/10 max-w-5xl mx-auto" />
            <div className="text-center text-white/60 text-sm pt-6">
                © 2026 Peticle. All rights reserved.
            </div>
        </footer>
    );
}

export default Footer;
